/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2023-02-01 10:03:54
 * @LastEditors: yuhaiyang yuhaiyangz@163.com
 * @LastEditTime: 2025-11-03 15:35:28
 * @Description: 接口封装
 */
/**
 * 网络请求配置
 */
import Axios, { AxiosInstance, AxiosRequestConfig,AxiosResponse } from "axios";
import { loadingManager } from "./loadingManager";
const defaultConfig: AxiosRequestConfig = {
    baseURL: process.env.REACT_APP_API,
    timeout: 1000 * 60 * 10,
    headers: { 'Content-Type': 'application/json' }
  };
  const axios: AxiosInstance = Axios.create(defaultConfig);
  //请求拦截
  axios.interceptors.request.use(
  (config) => {
    loadingManager.addLoading();
    return config;
  },
  (error) => {
    loadingManager.removeLoading();
    return Promise.reject(error);
  }
);

/**
 * http response 拦截器
 */
interface Result<T=any>{
  code:number,
  msg:any,
  data:T
}
axios.interceptors.response.use(
  (response:AxiosResponse<Result,any>) => {
    const { code } = response.data
    loadingManager.removeLoading();
    if(code !== 2000){
      return response;
    }else{
      return response
    }
    
  },
  (error) => {
    console.log("请求出错：", error);
    loadingManager.removeLoading();
    return Promise.reject(error)
  }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
function get(url:string, params = {}):Promise<Result> {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params,
      }).then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function post(url:string, data={}):Promise<Result> {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        //关闭进度条
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
function put(url:string, data={}):Promise<Result> {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        //关闭进度条
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
//统一接口处理，返回数据
export default function (fecth:'get'|'post'|'put', url:string, param={}):Promise<Result> {
  switch (fecth) {
    case "get":
      return get(url, param)
    case "post":
      return post(url, param)
    case "put":
      return put(url, param)
    default:
      return Promise.reject('err')
  }
}


